import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { CmsDestination } from '@fcom/core-api';
import { OndMarketingOffersService } from '@fcom/ond-marketing-landing-core/services/ond-marketing-offers.service';

@Component({
  selector: 'cms-ond-marketing-offers-list',
  template: ` <fin-ond-marketing-offers-list [destinationLocationCode]="destinationLocationCode$ | async" /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsOndMarketingOffersListComponent implements OnInit {
  private ondMarketingOffersService = inject(OndMarketingOffersService);

  @Input()
  content$: Observable<CmsDestination>;

  destinationLocationCode$: Observable<string>;

  ngOnInit(): void {
    this.destinationLocationCode$ = this.ondMarketingOffersService.getDestinationLocationCode(this.content$);
  }
}
